module.exports = __webpack_public_path__ + "media/images/custom_page/ab6ix_event/ab6ix-event-en-1bec25808ce7fbeee069115f8404f803.png";